import React from 'react'

const ProductSideEmpty = props => {
  return (
    <div className='cart-side col-8 pr-2'>
      <div className='border-ui-3 radius bg-white'>
        <div className='col-12 py-3 px-3 mx-0  border-color-ui-3 border-bottom'>
          Produto não encontrado
        </div>
      </div>
    </div>
  )
}

export default ProductSideEmpty



// WEBPACK FOOTER //
// ./src/Participant/MyOrders/ProductOrderDetail/ProductSide/ProductSideEmpty.js